import * as React from "react";
import { Icon } from "@grandvisionhq/icons";
var FoundationKey = /* @__PURE__ */ ((FoundationKey2) => {
  FoundationKey2["OneSightEssilorLuxotticaFoundation"] = "EL_ONESIGHT_FOUNDATION";
  return FoundationKey2;
})(FoundationKey || {});
const getFoundationKey = (value) => {
  const entry = Object.entries(FoundationKey).find(([_, enumValue]) => enumValue === value);
  return entry ? entry[1] : void 0;
};
const getDonationFoundationIcon = (foundationKey) => {
  const matchedFoundationKey = getFoundationKey(foundationKey);
  switch (matchedFoundationKey) {
    case "EL_ONESIGHT_FOUNDATION":
      return /* @__PURE__ */ React.createElement(Icon, { key: "onesight", name: "onesight", viewBox: "0 0 80 30", width: 80, height: 30 });
    default:
      return void 0;
  }
};
export {
  getDonationFoundationIcon
};
//# sourceMappingURL=get-donation-foundation-icon.js.map
